import "./style.css";
import Select from 'react-select';
import { useEffect, useState } from "react";
import DownloadCard from "./card/DownloadCard";
import { Box, CircularProgress, FormControl, InputLabel, Modal } from "@mui/material";
import servDownloads from "../../services/login/servDownloads";
import { WhiteInput } from "../../components/Inputs/InputText";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { OpcoesTipoDeDocumento } from "../../components/Combobox/TipoDeDocumento";
import { SearchFieldStyles } from "../../components/Searchfields/SearchFieldStyles";
import { style as modalStyle } from "../../components/Loading/Loading";

const Downloads = () => {
  const [downloadsDocumentos, setDownloadsDocumentos] = useState([]);
  const [tipoDocumento, setTipoDocumento] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filtro, setFiltro] = useState("");

  const tipoDocumentoColorMap = {
    1: "#1976D2",
    2: "#2E7D32",
    3: "#7B1FA2",
    4: "#EF6C00",
  };

  useEffect(() => {
    const recuperarDados = async () => {
      try {
        let dados;
        setIsLoading(true);
        dados = await servDownloads.Listar();

        setDownloadsDocumentos(dados.Content);
      } finally {
        setIsLoading(false);
      }
    }

    recuperarDados();
  }, []);

  const onClickPesquisar = async () => {
    try {
      setIsLoading(true);

      const tiposSelecionados = tipoDocumento.map(t => t.value);

      const dados = await servDownloads.Listar(
        filtro,
        tiposSelecionados
      );

      setDownloadsDocumentos(dados.Content ?? []);

    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="downloads-container">
        <div style={{ margin: '0 0 0 15px' }}>
          <h3>Normas técnicas</h3>
          <p style={{ color: "white" }}>
            Acesse legislação, normas, modelos de documentos e outros arquivos
            importantes
          </p>
        </div>

        <div className="documentos-filtros">
          <FormControl variant="outlined">
            <InputLabel shrink style={{ color: "#B8B8B8" }}>
              Pesquisa geral
            </InputLabel>
            <WhiteInput
              value={filtro}
              onChange={(e) => setFiltro(e.target.value)}
              placeholder="Nome"
              id="pesquisa-documento"
              sx={{ width: "488px", margin: "0px 18px" }}
            />
          </FormControl>

          <FormControl
            variant="outlined"
            sx={{ zIndex: "100" }}
          >
            <InputLabel
              htmlFor="pesquisa-tipo-documento"
              shrink
              style={{ color: "#B8B8B8" }}
            >
              Tipo de documento
            </InputLabel>
            <Select
              isMulti
              value={tipoDocumento}
              onChange={(value) => setTipoDocumento(value)}
              options={OpcoesTipoDeDocumento}
              styles={SearchFieldStyles}
              placeholder="Selecione o tipo"
              formatOptionLabel={(option) => (
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: tipoDocumentoColorMap[option.value],
                    }}
                  />
                  {option.label}
                </div>
              )}
            />
          </FormControl>

          <BlueHoverButton
            variant="contained"
            onClick={onClickPesquisar}
            style={{ marginLeft: "20px", marginBottom: "5px" }}
          >
            Pesquisar
          </BlueHoverButton>
        </div>

        <div className="cards-container">
          {downloadsDocumentos.length > 0 ? (
            downloadsDocumentos.map((doc) => (
              <DownloadCard
                key={doc.Id}
                documento={doc}
              />
            ))
          ) : (
            <div className="empty-state">
              Nenhum documento encontrado.
            </div>
          )}
        </div>
      </div>

      <Modal open={isLoading} >
        <Box style={modalStyle} >
          <CircularProgress color="inherit" />
        </Box>
      </Modal>
    </>
  )
}

export { Downloads };